import { Dialog, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Content, ContentText, AlertText } from "./styles";
import DialogActions from "../DialogActions/DialogActions";
import DialogTitle from "../DialogTitle/DialogTitle";

interface Props {
  open: boolean;
  handleCancel: () => void;
  handleDiscard: () => void;
  alertAddTextKey?: string; // key for additional message to show
}

const ConfirmationChangesDialog = ({ open, handleCancel, handleDiscard, alertAddTextKey }: Props) => {
  const { t } = useTranslation();
  const tRP = "components.confirmation_changes_dialog"; // tRP - translation root path

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
    >
      <DialogTitle
        title={t(`${tRP}.title`)}
        handleClose={handleCancel}
      />
      <Content>
        <ContentText>{`${t(`${tRP}.message`)}`}</ContentText>
        {alertAddTextKey && <AlertText>{`${t(alertAddTextKey)}`}</AlertText>}
      </Content>
      <DialogActions
        handleCancel={handleCancel}
        useGoback
      >
        <Button
          onClick={handleDiscard}
          variant="contained"
          color="error"
        >
          {`${t("buttons.discard")}`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationChangesDialog;
